import { SVGMap } from "./svg-map"

/**
 * @constructor
 * @augments SVGMap
 * @class SVG LayoutMap.
 */
let LayoutMap=function(id, left, top, width, height) {

  var b= this.bounds= { x:left || 0, y:top || 0, width:width || 10, height:height || 10 },
      lat = 0,
      lon = 0;

  SVGMap.call(this, id, 0, 0, b.width, b.height);

  this.size.offx=0;
  this.size.offy=0;

  var d=document, p, gg, txt,
      ns=this.ns,
      po="points",
      _this=this,
      content=this.content;
	  
  /**
   * Draws a path
   */   
  this.nPPath=function(t, instruct, clr, wdth, ps) {
    //if ((!_this.filter) || (_this.filter.indexOf(t)!=-1)) {
      p=d.createElementNS(ns, "path");
      p.setAttribute("d", instruct);
      p.setAttribute(po,ps);
	  p.style.stroke=clr;
	  p.style.strokeWidth=wdth;
      content.appendChild(p);
	//}
  }	  
 /*newpath = document.createElementNS("SVG","path");  
newpath.setAttribute("id", "pathIdD");  
newpath.setAttribute("d", "M 1,97.857143 C 19.285714,96.428571 24.016862,131.64801 90.714286,132.85714 140.78762,133.7649 202.79376,66.16041 202.79376,66.16041");  
newpath.setAttribute("stroke", "black");  
newpath.setAttribute("stroke-width", 3);  
newpath.setAttribute("opacity", 1);  
newpath.setAttribute("fill", "none");

document.getElementById("fullPageID").appendChild(newpath);*/

  /**
   * Draws a polygon
   * @param {string} t element id.
   * @param {point[]} ps Polygon points.
   */
  this.nP=function nP(t, ps) {
    if ((!_this.filter) || (_this.filter.indexOf(t)!=-1)) {
      p=d.createElementNS(ns, "polygon");
      p.setAttribute("id", t);
      p.setAttribute(po,ps);
      content.appendChild(p);
    }
  }

  /**
   * Draws a circle/ellipse
   * @param {string} t element id.
   * @param {number} aX Centre x location.
   * @param {number} aY Centre y location.
   * @param {number} aRX x radius.
   * @param {number} aRX y radius.
   */  
  this.nC=function(t, aX, aY, aRX, aRY) {  //circle/ellipse

    var shape = d.createElementNS(ns, "ellipse");
    shape.setAttribute("cx", aX);
    shape.setAttribute("cy", aY);
    shape.setAttribute("rx",  aRX);
	shape.setAttribute("ry",  aRY);
	shape.setAttribute("id",  t);
    //shape.setAttributeNS(null, "fill", aColor);
    
    content.appendChild(shape);
}

  /**
   * Draws a polygon
   * @param {string} t element id.
   * @param {Color} clr Stroke color.
   * @param {number} wdth Stroke width.
   * @param {point[]} ps Polygon points.
   */   
  this.nPEnh=function(t, clr, wdth, ps) {
    if ((!_this.filter) || (_this.filter.indexOf(t)!=-1)) {
      p=d.createElementNS(ns, "polygon");
      p.setAttribute("id", t);
      p.setAttribute(po,ps);
	  p.style.stroke=clr;
	  p.style.strokeWidth=wdth;
      content.appendChild(p);
  }
}

/*
  function nP(t, ps) {
    if ((!_this.filter) || (_this.filter.indexOf(t)!=-1)) {
      p=d.createElementNS(ns, "polygon");
      p.setAttribute("id", t);
      p.setAttribute(po,ps);
      content.appendChild(p);
    }
  }
*/

  /**
   * Draws a text element
   * @param {string} t element id.
   * @param {number} aX Text x location.
   * @param {number} aY Text y location.
   * @param {string} aFamily Font family.
   * @param {string} text Text to render.
   */ 
  this.nPTxt=function(t, aX, aY, aFamily, text) {
    if ((!_this.filter) || (_this.filter.indexOf(t)!=-1)) {
      txt=d.createElementNS(ns, "text");
      //txt.setAttribute("id", t);
      txt.setAttribute("textContent",text);
	  txt.setAttribute("x",aX);
	  txt.setAttribute("y",aY);
	  //txt.setAttribute("fill", "blue");
      txt.setAttribute("font-family", aFamily);

      content.appendChild(txt);
    }
    }
  
  this.labels={AF: "PN"};

  this.svg.appendChild(content);
  }  

LayoutMap.prototype = new SVGMap();

export { LayoutMap }
